import React, { useState } from 'react'
import { Box, makeStyles, Tab } from '@material-ui/core'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import {
  VALUE_ADDED_SERVICES_TAB_LIST,
  VALUE_ADDED_SERVICES_TABS,
} from 'src/utils/constants/common'
import { unset } from 'lodash'
import BuyNewCarOrBike from 'src/components/Individual/AddedServices/BuyNewCarOrBike'
import buyNewVehicleImage from 'src/assets/AddedServices/buyNewCarImage.svg'
import rings from 'src/assets/AddedServices/rings.svg'
import MarriageOrNewBorn from 'src/components/Individual/AddedServices/MarriageOrNewBorn'
import ComingSoon from 'src/components/common/ComingSoon'
import HomeLoanImage from 'src/assets/AddedServices/homeLoan.svg'
import TrovityCardImage from 'src/assets/AddedServices/trovityCard.svg'
import TravelPlansImage from 'src/assets/AddedServices/travelPlans.svg'
import { Tooltip, Zoom } from '@mui/material'

const ValueAddedServices = () => {
  const classes = useStyles()
  const [value, setValue] = useState(
    VALUE_ADDED_SERVICES_TABS?.BUY_A_NEW_CAR_BIKE
  )
  const handleTabChange = (event, newValue) => {
    setValue(newValue)
  }

  const getTabName = (tabName) => {
    switch (tabName) {
      case VALUE_ADDED_SERVICES_TABS?.BUY_A_NEW_CAR_BIKE:
        return (
          <div className={classes.mainTab}>
            <img src={buyNewVehicleImage} alt='buyNewVehicleImage' />
            <span className={classes.redColoredText}>Buy New Car/Bike</span>
          </div>
        )
      case VALUE_ADDED_SERVICES_TABS?.MARRIAGE_NEWBORN:
        return (
          <div className={classes.mainTab}>
            <img src={rings} alt='rings' />
            <div>
              <div id='marriage'>Marriage/NewBorn</div>
              <span className={classes.redColoredText}>
                Don&apos;t Miss to Read
              </span>
            </div>
          </div>
        )
      case VALUE_ADDED_SERVICES_TABS?.HOME_LOAN:
        return (
          <Tooltip
            TransitionComponent={Zoom}
            placement='bottom'
            title={'Coming Soon'}
            arrow
          >
            <div className={classes.mainTab}>
              <img src={HomeLoanImage} alt='HomeLoanImage' />
              <div>
                <div id='homeLoan'>Home Loan</div>
              </div>
            </div>
          </Tooltip>
        )
      case VALUE_ADDED_SERVICES_TABS?.TROVITY_ONE_CARD:
        return (
          <Tooltip
            TransitionComponent={Zoom}
            placement='bottom'
            title={'Coming Soon'}
            arrow
          >
            <div className={classes.mainTab}>
              <img src={TrovityCardImage} alt='TrovityCardImage' />
              <div>
                <div id='trovityOneCard'>Trovity OneCard</div>
              </div>
            </div>
          </Tooltip>
        )
      case VALUE_ADDED_SERVICES_TABS?.TRAVEL_PLANS:
        return (
          <Tooltip
            TransitionComponent={Zoom}
            placement='bottom'
            title={'Coming Soon'}
            arrow
          >
            <div className={classes.mainTab}>
              <img src={TravelPlansImage} alt='TravelPlansImage' />
              <div>
                <div id='travelPlan'>Travel Plans</div>
              </div>
            </div>
          </Tooltip>
        )
      default:
        return <></>
    }
  }
  const getTabComponents = (tabName) => {
    switch (tabName) {
      case VALUE_ADDED_SERVICES_TABS?.BUY_A_NEW_CAR_BIKE:
        return <BuyNewCarOrBike />
      case VALUE_ADDED_SERVICES_TABS?.MARRIAGE_NEWBORN:
        return <MarriageOrNewBorn />
      case VALUE_ADDED_SERVICES_TABS?.HOME_LOAN:
        return <ComingSoon />
      case VALUE_ADDED_SERVICES_TABS?.TROVITY_ONE_CARD:
        return <ComingSoon />
      case VALUE_ADDED_SERVICES_TABS?.TRAVEL_PLANS:
        return <ComingSoon />
      default:
        return <BuyNewCarOrBike />
    }
  }
  return (
    <>
      <Box className={classes.boxContainer}>
        <TabContext value={value}>
          <Box>
            <TabList
              id='tabList'
              onChange={handleTabChange}
              className={classes.tablistStyles}
              variant='scrollable'
            >
              {VALUE_ADDED_SERVICES_TAB_LIST?.map((tabListItem) => (
                <Tab
                  key={`tab_${tabListItem?.type}`}
                  label={getTabName(tabListItem?.type)}
                  value={tabListItem?.type}
                  wrapped
                  className={`${
                    value === tabListItem?.type
                      ? classes.tabSelected
                      : classes.tab
                  } ${classes.autoPointerEvents}`}
                  disabled={tabListItem?.isDisabled}
                />
              ))}
            </TabList>
          </Box>
          <>
            {VALUE_ADDED_SERVICES_TAB_LIST?.map((tabListItem) => (
              <TabPanel
                value={tabListItem.type}
                className={classes.tabPanel}
                key={`tabPanel_${tabListItem?.type}`}
              >
                {getTabComponents(tabListItem?.type)}
              </TabPanel>
            ))}
          </>
        </TabContext>
      </Box>
    </>
  )
}

export default ValueAddedServices

const useStyles = makeStyles((theme) => ({
  policyDetailViewContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    maxHeight: '90%',
    background: 'transparent',
  },
  gridHeaders: {
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    background: 'linear-gradient(360deg, #AFAFAF -208.33%, #FFFFFF 71.79%)',
    padding: '10px 5px',
    borderRadius: '10px',
  },
  headerItems: {
    padding: '10px',
    borderRadius: '10px',
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
  },
  headers: {},
  boxContainer: {
    height: 'fit-content',
    backgroundColor: 'white',
    justifyContent: 'center',
    alignItems: 'center',
    animation: `$slideEffect 1000ms ${theme.transitions.easing.easeInOut}`,
  },
  '@keyframes slideEffect': {
    '0%': {
      opacity: 0,
      transform: 'translate(-10%, 10% , 10%)',
    },
    '100%': {
      opacity: 1,
      transform: 'translateX(0%)',
    },
  },
  tablistStyles: {
    textTransform: unset,
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    background: ' linear-gradient(360deg, #AFAFAF -208.33%, #FFFFFF 71.79%)',
    borderRadius: '10px',
    '& .MuiTabs-flexContainer': {
      gap: '20px',
      padding: '10px',
      borderRadius: '10px',
    },
    '& .MuiTabs-indicator': {
      backgroundColor: ' unset !important',
    },
  },
  tab: {
    lignItems: 'center',
    justifyContent: 'center',
  },

  tabSelected: {
    color: '#000000 !important',
    backgroundColor: 'white',
    border: '1px solid #B92250',
    borderRadius: '7px',
  },
  redColoredText: {
    color: '#B92250',
  },
  mainTab: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    gap: 5,
  },
  autoPointerEvents: {
    pointerEvents: 'auto !important',
    cursor: 'pointer !important',
  },
}))
